if (typeof ScatterPlot !== " function") {
  window.ScatterPlot = function (wrapper, duracion, data) {
    let box = new Box({
      size: { width: 900, height: 900 },
      padding: { top: 100, right: 80, bottom: 40, left: 200 },
    });

    let svg = null;

    let gEjeX = null;
    let gEjeY = null;
    let gMain = null;

    window.color = d3
      .scaleOrdinal()
      .domain(["Chihuahua", "Durango", "Sinaloa"])
      .range(["#6a9f58", "#e49444", "#5778a4"]);

    let escalaX = d3
      .scaleLinear()
      .domain([0, 54])
      .range([0, box.content.width]);

    let escalaY = d3
      .scaleLinear()
      .domain([2015, 2025])
      .range([box.content.height, 0]);

    let escalaRadio = d3.scaleSqrt().domain([0, 2000]).range([0, 15]);

    function setup() {
      data = d3.sort(
        data,
        (a, b) =>
          d3.ascending(a.fecha, b.fecha) ||
          d3.descending(a.superficie, b.superficie)
      );
      let grupos = d3.group(data, (d) => d.anio);

      crearSVG();
      main(grupos);
    }

    function crearSVG() {
      svg = wrapper
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr("viewBox", `0 0 ${box.width} ${box.height}`);

      svg = svg.append("g");

      svg = svg
        .append("g")
        .attr(
          "transform",
          `translate(${box.padding.left}, ${box.padding.top})`
        );

      svg
        .append("text")
        .text(data[0].estado)
        .attr("x", box.content.width / 2)
        .attr("y", -70)
        .style("start-anchor", "middle")
        .style("dominant-baseline", "hanging");

      gEjeX = svg
        .append("g")
        .attr("transform", `translate(0, ${box.content.height})`)
        .attr("data-g", "gEjeX");
      gEjeY = svg.append("g").attr("data-g", "gEjeY");
      gMain = svg.append("g").attr("data-g", "gMain");

      gEjeX
        .call(d3.axisBottom(escalaX))
        .selectAll("text")
        .style("text-anchor", "middle");

      gEjeY.call(
        d3
          .axisLeft(escalaY)
          .tickSizeInner(0)
          .tickSizeOuter(0)
          .tickFormat((d) => `${d}`)
      );
    }

    function main(grupos) {
      let gs = gMain
        .selectAll("g.incendios")
        .data(grupos)
        .join("g")
        .attr("class", "incendios")
        .attr("fill", "none")
        .attr("stroke", (d) => color(d[1][0].estado))
        .attr("stroke-width", 1)
        .attr("transform", (d) => `translate(0,${escalaY(d[0])})`);

      gs.selectAll("circle")
        .data((d) => d[1])
        .join("circle")
        .attr("r", (d) => escalaRadio(d.superficie))
        .attr("cx", (d) => escalaX(d.semana))
        .attr("cy", 0);
    }

    setup();
  };
}
